<template>
  <div class="spa-nav container-fluid px-0">

    <h1 class="guide-title title_h1_pink">{{ guideTitle }}</h1>

    <nav class="navbar text-center navbar-expand-md navbar-wrapper" :class="{ 'mb-3': !contentFiltersIsOpen }">
      <div class="navbar-collapse justify-content-start nav-items-wrapper">
        <div class="nav navbar-nav router-links-wrapper justify-content-center nav-pills bg-white">
          <router-link
            to="/by-competition"
            @click="resetAllFilters"
            class="nav-item nav-link"
            active-class="active"
            role="link">{{ lang=='he-IL'? 'לפי מסגרות':'By category' }}
            </router-link> <!-- .nav-item -->
          <router-link
            to="/schedule"
            @click="resetAllFilters"
            class="nav-item nav-link"
            active-class="active"
            role="link">{{ lang=='he-IL'? 'לפי תאריך':'By date' }}
            </router-link> <!-- .nav-item -->
          <router-link
            to="/by-abc"
            @click="resetAllFilters"
            class="nav-item nav-link"
            active-class="active"
            role="link">{{ lang=='he-IL'? 'לפי א-ב':'By ABC' }}
            </router-link>

        </div> <!-- .nav -->

        <div class="nav navbar-nav justify-content-center nav-pills bg-white hidden-on-mobile">
          <div class="nav-item nav-link filter-wrapper" id="dates-filter-wrapper"> 
           <span @click="toggleDatesFilter">
              {{ lang=='he-IL'? 'תאריך':'Date' }}
           </span> 
            <svg @click="toggleDatesFilter" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" class="w-6 h-6" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="m20 8-7 8-7-8"/>
            </svg>
            <date-filter v-show="datesFilterIsOpen" :isOpen="datesFilterIsOpen"/>
          </div>
        </div> <!-- .nav -->
        <div class="nav navbar-nav justify-content-center nav-pills bg-white">
          <div class="nav-item nav-link filter-wrapper" id="content-filters-wrapper">
           <span @click="toggleContentFilters">
            {{ lang=='he-IL'? 'סננים':'Filters' }}
            </span> 
            <svg @click="toggleContentFilters" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" class="w-6 h-6" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="m20 8-7 8-7-8"/>
            </svg>
          </div>
        </div> <!-- .nav -->
        <div class="search-wrapper nav navbar-nav bg-white">
          <input
            @input="handleSearchInput"
            type="text"
            class="form-control"
            :placeholder="searchPlaceholderText"
            aria-label="Search" >
          <div class="input-group-append search-btn-wrapper">
            <span class="search-btn input-group-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor">
                <path d="M11.7 10.3a6.5 6.5 0 1 0-1.4 1.4l.1.2 3.9 3.8a1 1 0 0 0 1.4-1.4L12 10.4a1 1 0 0 0-.2 0zm.3-3.8a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="nav navbar-nav justify-content-center nav-pills bg-white reset-button-wrapper hidden-on-mobile">
          <div class="nav-item nav-link filter-wrapper" id="dates-filter-wrapper"> 
            <span @click="resetAllFilters">
              {{ lang=='he-IL'? 'נקה':'Reset' }}
              </span> 
          </div>
        </div>
      </div> <!-- .navbar-collapse -->
    </nav> <!-- navbar -->
    <content-filters v-show="contentFiltersIsOpen" :isOpen="contentFiltersIsOpen"/>
  </div><!-- #spa-nav -->
</template>

<script>
import DateFilter from './AppDateFilter.vue';
import ContentFilters from './AppContentFilters.vue';

export default {
	components: {
		'date-filter': DateFilter,
		'content-filters': ContentFilters
	},
	data() {
		return {
			searchTerm: '',
      lang: 'he-IL',
      searchDebounceResolveID: null,
      datesFilterIsOpen: false,
      contentFiltersIsOpen: false,
		};
	},
  methods: {
    handleSearchInput(e) {
      if (this.searchDebounceResolveID) clearTimeout(this.searchDebounceResolveID)
      const that = this
      this.searchDebounceResolveID = setTimeout(function() {
        that.searchTerm = e.target.value
        if (that.$route.name !== 'by-abc') {
          that.$router.push('by-abc')
          setTimeout(_ => that.emitter.emit('searchTermChanged', that.searchTerm), 1000);
        }
        else that.emitter.emit('searchTermChanged', that.searchTerm);
      }, 700)
    }, 
    toggleDatesFilter() {
      if (this.datesFilterIsOpen) this.closeDatesFilter()
      else this.openDatesFilter()
    },
    toggleContentFilters() {
      if (this.contentFiltersIsOpen) this.closeContentFilters()
      else this.openContentFilters()
    },
    openDatesFilter() {
      document.querySelector('#dates-filter-wrapper').classList.add('active')
      this.datesFilterIsOpen = true
      document.body.addEventListener("click", this.closeDatesFilterOnBodyClick)
    },
    closeDatesFilterOnBodyClick(e) {
        let testElm = e.target
        for (let i=0; i<5; i++) {
          if (testElm == document.querySelector('#dates-filter-wrapper')) return
          testElm = testElm.parentNode
        }
        this.closeDatesFilter()
        document.body.removeEventListener("click", this.closeDatesFilterOnBodyClick)
    },
    closeDatesFilter() {
      document.querySelector('#dates-filter-wrapper').classList.remove('active')
      this.datesFilterIsOpen = false
    },
    openContentFilters() {
      document.querySelector('#content-filters-wrapper').classList.add('active')
      this.contentFiltersIsOpen = true
    },
    closeContentFilters() {
      document.querySelector('#content-filters-wrapper').classList.remove('active')
      this.contentFiltersIsOpen = false
    },
    resetAllFilters() {
      // search filter
      document.querySelector('.search-wrapper input.form-control').value = ''
      this.searchTerm = ''
      this.emitter.emit('searchTermChanged', this.searchTerm);

      // dates filter
      this.emitter.emit('resetDatesFilter', true)
      this.openDatesFilter()

      // content filters
      this.emitter.emit('resetAllContentFilters')
      this.closeContentFilters()

      //refilter
      this.emitter.emit('resetFilteredPosts')

    }
  }, 
  computed: {
    guideTitle() {
      if (this.lang == 'he-IL') return this.$route.name=='schedule'? 'לוח הזמנים': 'תכניית הפסטיבל'
      else return this.$route.name=='schedule'? 'Schedule': 'Festival program'
    },
    searchPlaceholderText(){
      return this.lang=='he-IL'?'חיפוש':'Search';
    }
  },
  mounted() {
    this.emitter.on('closeDatesFilter', this.closeDatesFilter)
    this.emitter.on('resetAllFilters', this.resetAllFilters)
    this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
  }
};
</script>

<style scoped>
.navbar-wrapper {
  margin-bottom: 1em
}
.navbar {
  padding: 0;
}

.navbar-nav {
  border: 2px solid black;
  margin-inline-end: 1em;
}
.nav-link {
  transition: all 400ms;
  padding: .1rem 1rem !important;
}
a.nav-link {
  outline: none !important;
}
.spa-nav .nav-pills .nav-link.active,
.spa-nav .nav-pills .show > .nav-link {
	background-color: black;
	border-radius: 0;
}

@media only screen and (max-width: 768px) {
  .navbar-nav {
    margin-inline-end: 0;
	}
  a.nav-link {
    width: 33%;
    font-size: 1.4em;
  }
  .router-links-wrapper {
    flex-direction: row;
  }
  .hidden-on-mobile {
    display: none;
  }
  .search-wrapper {
    width: 50%;
  }
  .search-wrapper input.form-control {
    font-size: 1.5em;
  }
  .nav-items-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1em;
  }
  .router-links-wrapper {
    width: 100%;
  }
  .navbar-nav .nav-link {
    font-size: 1.4em;
  }

  .spa-nav .nav-pills .nav-link {
    text-align: center;
  }
}

.spa-nav a {
	color: #35495e;
}

h1.guide-title {
  color: #F15794;
}

.filter-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;
  padding-inline: 0.5em !important;
}

.filter-wrapper.active {
  color: white;
  background-color: black;
}

.filter-wrapper > svg {
  transition: 300ms ease-in-out;
}
.filter-wrapper.active > svg {
  transform: rotate(360deg) scale(-1);
}

.search-wrapper {
  border: 2px solid black;
  padding: 0.5px 0 0 0 !important;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  flex-wrap: nowrap;
  max-width: 300px;
}
.search-wrapper input {
  border: none;
  padding: 0 !important;
  font-size: 1em;
  outline: none !important;
  box-shadow: none;
  margin-inline-start: 0.5em;
  line-height: 1.3em;
}
.search-wrapper input::placeholder {
  color: black;
  opacity: 1;
  transition: 200ms;
}
.search-wrapper input:focus::placeholder {
  opacity: 0.7;
}
.search-btn-wrapper {
  width: fit-content;
}
.search-btn {
  background: none;
  border: none;
  padding: .1rem 0.5rem !important;
  cursor: pointer;
}
.reset-button-wrapper {
  margin-right: 65px;
}

</style>
